import { KEYS as KEYS_IMPORT } from "./constants";
import { Logger } from "./logger";
import { argsToMap } from "./util";
export const KEYS = KEYS_IMPORT;
export const SFLogger = (config, ...args)=>{
    return new Logger(config, argsToMap(...args));
};
